import { legacy_createStore as createStore, combineReducers } from "redux";

import customizationReducer from "./customizationReducer";
import snackbarReducer from "./snackbarReducer";
import spinnerReducer from "./spinnerReducer";
import modalReducer from "./modalReducer";

const rootReducer = combineReducers({
    customization: customizationReducer,
    snackbar: snackbarReducer,
    spinner: spinnerReducer,
    modal: modalReducer
});

export const store = createStore(rootReducer);

export type RootState = ReturnType<typeof rootReducer>;
